// extracted by mini-css-extract-plugin
export default {"totals":"eZP_C","list-item":"W9uH5","totals-header":"oBHzZ"};